import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { HeatIndexStandard } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, HeatIndexStandard[]>,
    'queryKey' | 'queryFn'
  >;
}

export const useHeatIndexStandardListRequest = ({
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, HeatIndexStandard[]>(
    [Entities.HeatIndexStandards],
    async () => {
      const { data } = await api.v1AdminStandardsHeatIndexGet()
      return data as HeatIndexStandard[]
    },
    options,
  )
}
